import axios from 'axios'
// ⭐ BUG-015：与路由守卫共用的「未登录落点」判定（含 window.location.href 场景）
import { buildLoginUrl } from '@/utils/wechatEnv'
import authApi from './services/authApi'
// import spacesApi from './services/spacesApiWx'
// import spacesWebApi from './services/spacesWebApiWx'
// import pagesApi from './services/pagesApi'
import usersApi from './services/usersApi'
// import searchApi from './services/searchApi'
// import foldersApi from './services/foldersApiWx'
// import aiInternetApi from './services/aiInternetApi'
import wechatAuthApi from './services/wechatAuthApi'
// import wechatDriveApi from './services/wechatDriveApi'
// import wechatMessageApi from './services/wechatMessageApi'
// import filesApi from './services/filesApiWx'
// import filesWebApi from './services/filesWebApiWx'
// import arcApi from './services/arcApi'
// import actionsApi from './services/actionsApi'
// import alertApi from './services/alertApiWx'
// import financePerformanceApi from './services/financePerformanceApiWx'
// import financePerformanceWebApi from './services/financePerformanceWebApiWx'
// import financePerformanceChannelWebApi from './services/financePerformanceChannelWebApiWx'
// import productPerformanceApi from './services/productPerformanceApiWx'
// import productPerformanceWebApi from './services/productPerformanceWebApiWx'
// import productPerformanceChannelWebApi from './services/productPerformanceChannelWebApiWx'
// import productPerformanceChannelScmWebApi from './services/productPerformanceChannelScmWebApiWx'
// import approvalApi from './services/approvalApiWx'
// import approvalWebApi from './services/approvalWebApiWx'
// import messageApi from './services/messageApiWx'
import funnelApi from './services/funnelApiWx'
import divisionOrgSalesApi from './services/divisionOrgSalesApiWx'
import divisionOrgSalesWebApi from './services/divisionOrgSalesWebApiWx'
// import alertWebApi from './services/alertWebApiWx'
// import actionWebApi from './services/actionWebApiWx'
// import messageWebApi from './services/messageWebApiWx'
import funnelWebApi from './services/funnelWebApiWx'
// import skuForecastApi from './services/skuForecastApiWx'
// import skuForecastWebApi from './services/skuForecastWebApiWx'

// 创建axios实例
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 添加认证token
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      console.log('[API] 添加Authorization头:', `Bearer ${token.substring(0, 10)}...`) // 只打印token前10位
      console.log('[API] 请求URL:', config.url)
      console.log('[API] 请求方法:', config.method)
      config.headers['Authorization'] = `Bearer ${token}`
    } else {
      console.warn('[API] 未找到token，跳过认证头添加')
    }
    return config
  },
  error => {
    console.error('[API] 请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器 - 处理常见错误
apiClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // 处理401错误 - 未授权
    if (error.response && error.response.status === 401) {
      // 清除本地存储的token
      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      
      // ⭐ BUG-015：统一经判定计算落点（企微容器内 ⇒ 自动走 Agent 微信授权）
      // ⚠️ 此处用 window.location.href 硬跳转，**绕过 vue-router 守卫**，
      //    因此必须与路由守卫共用同一判定，否则 token 过期时会回到账号密码页。
      if (window.location.pathname !== '/login' && window.location.pathname !== '/login/wechat/Agent') {
        window.location.href = buildLoginUrl(window.location.pathname)
      }
    }
    
    // 处理403错误 - 禁止访问
    if (error.response && error.response.status === 403) {
      console.error('Access forbidden:', error.response.data)
    }
    
    // 处理422错误 - 数据验证失败
    if (error.response && error.response.status === 422) {
      console.error('[API] 数据验证失败:', error.response)
      console.error('[API] 数据验证失败:', error.response.data)
      // 检查是否是token问题
      if (error.response.data?.detail?.includes('token') || 
          error.response.data?.message?.includes('token')) {
        console.warn('[API] Token可能无效或过期')
        // 清除无效token
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        // ⭐ BUG-015：同 401 分支，统一经判定计算落点（详见下方注释）
        if (window.location.pathname !== '/login' && window.location.pathname !== '/login/wechat/Agent') {
          window.location.href = buildLoginUrl(window.location.pathname)
        }
      }
    }
    
    // 处理500错误 - 服务器错误
    if (error.response && error.response.status >= 500) {
      console.error('[API] 服务器错误:', error.response.data)
    }
    
    return Promise.reject(error)
  }
)

// 导出API服务
export default {
  authApi: authApi(apiClient),
  // spacesApi: spacesApi(apiClient),
  // spacesWebApi: spacesWebApi(apiClient),
  // pagesApi: pagesApi(apiClient),
  usersApi: usersApi(apiClient),
  // searchApi: searchApi(apiClient),
  // foldersApi: foldersApi(apiClient),
  // aiInternetApi: aiInternetApi(apiClient),
  wechatAuthApi: wechatAuthApi(apiClient),
  // wechatDriveApi: wechatDriveApi(apiClient),
  // wechatMessageApi: wechatMessageApi(apiClient),
  // filesApi: filesApi(apiClient),
  // filesWebApi: filesWebApi(apiClient),
  // arcApi: arcApi(apiClient),
  // actionsApi: actionsApi(apiClient),
  // alertApi: alertApi(apiClient),
  // financePerformanceApi: financePerformanceApi(apiClient),
  // financePerformanceWebApi: financePerformanceWebApi(apiClient),
  // financePerformanceChannelWebApi: financePerformanceChannelWebApi(apiClient),
  // productPerformanceApi: productPerformanceApi(apiClient),
  // productPerformanceWebApi: productPerformanceWebApi(apiClient),
  // productPerformanceChannelWebApi: productPerformanceChannelWebApi(apiClient),
  // productPerformanceChannelScmWebApi: productPerformanceChannelScmWebApi(apiClient),
  // approvalApi: approvalApi(apiClient),
  // approvalWebApi: approvalWebApi(apiClient),
  // messageApi: messageApi(apiClient),
  funnelApi: funnelApi(apiClient),
  divisionOrgSalesApi: divisionOrgSalesApi(apiClient),
  // alertWebApi: alertWebApi(apiClient),
  // actionWebApi: actionWebApi(apiClient),
  // messageWebApi: messageWebApi(apiClient),
  funnelWebApi: funnelWebApi(apiClient),
  // skuForecastApi: skuForecastApi(apiClient),
  // skuForecastWebApi: skuForecastWebApi(apiClient),
  divisionOrgSalesWebApi: divisionOrgSalesWebApi(apiClient)
}

// 导出axios实例，以便在需要时直接使用
export { apiClient }